/* eslint-disable indent */
/* eslint-disable object-property-newline */
import React from "react";
import { withTranslation } from "react-i18next";
import {
  Card, CardBody, CardHeader, CardTitle,
} from "reactstrap";
import Accordion from "react-bootstrap/Accordion";

import "./AgreementDetails.css";

import {
  Table, Thead, Tbody, Tr, Th, Td
} from "react-super-responsive-table";
import { useSelector } from "react-redux";

const getAccountTypeName = (accountTypeId, accountTypes) => {
  return accountTypes?.find((type) => type._id === accountTypeId)?.title;
};

const getAccountType = (accountTypeId, accountTypes) => {
  return accountTypes?.find((type) => type._id === accountTypeId);

};

const getColorByAccountType = (accountTypeId) => {
  if (!accountTypeId) return "#7f8c8d";

  let hash = 0;
  for (let i = 0; i < accountTypeId.length; i++) {
    hash = accountTypeId.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash) % 360;

  const saturation = 65;
  const lightness = 55;

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

const getTotalRebate = (accountTypeId, totals) => {
  return totals?.find((total) => total.accountTypeId === accountTypeId)?.rebate;
};

const getTotalCommission = (accountTypeId, totals) => {
  return totals?.find((total) => total.accountTypeId === accountTypeId)?.commission;
};


const AgreementDetails = ({ agreement, accountTypes, t }) => {
  const { clientDetails } = useSelector(state => state.clientReducer);
  return (
    <>
    <div className="legend-container">
        <div className="legend-item">
          <span className="legend-dot green"></span>
          Selected Account
        </div>
        <div className="legend-item">
          <span className="legend-dot orange"></span>
          Sub IB
        </div>
      </div>
    <Card>
      <CardHeader className="py-3">
        <CardTitle className="color-primary">{t("Agreement Details")}</CardTitle>
      </CardHeader>
      <CardBody>
        {/* {agreement ?
          !agreement?.isMaster &&
          <>
            <Table className="table table-hover table-borderless spaced-table">
              <Thead>
                <Tr>
                  <Th className="py-1">{t("Account Type")}</Th>
                  <Th className="py-1">{t("Total Rebate")}</Th>
                  <Th className="py-1">{t("Total Commission")}</Th>
                </Tr>
              </Thead>
              <Tbody>
                {agreement?.totals?.map((total, idx) =>
                  <Tr key={idx}>
                    <Td className="py-1 table-row">{getAccountTypeName(total.accountTypeId, accountTypes)}</Td>
                    <Td className="py-1 table-row">{total.rebate}</Td>
                    <Td className="py-1 table-row">{total.commission}</Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </>
          : <p>No Agreements for this account.</p>} */}
        <Accordion className="accordion">
          {agreement?.members?.map((member, index) =>
            <Accordion.Item eventKey={index} key={member._id}>
              <Accordion.Header className={clientDetails?._id === member?.customerId?._id ? "accordion-green" : "accordion-sub"}>
                {member.customerId.firstName} {member.customerId.lastName}
              </Accordion.Header>
              <Accordion.Body>
                <Accordion>
                  <div className="accordion-table-header">
                        <div>Account Type</div>
                        <div>Rebate</div>
                        <div>Commission</div>
                      </div>
                  {member?.values.map((account, index) =>
                    getAccountType(account?.accountTypeId, accountTypes)?.type === "INVESTOR" ? <>
                      <Accordion.Item eventKey={index} key={account._id}>
                        <Accordion.Header style={{
                          color: "black",
                          fontWeight: "bold"
                        }}>{getAccountTypeName(account.accountTypeId, accountTypes)}</Accordion.Header>
                        <Accordion.Body>
                          <Table className="table table-hover table-borderless text-center text-capitalize">
                            <Thead>
                              <Tr>
                                <Th className="py-1">{t("PAMM Profit Share")}</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              <Tr >
                                <Td className="py-1">
                                  {account?.pamProfitShare ?? 0} %
                                </Td>
                              </Tr>
                            </Tbody>
                          </Table>
                        </Accordion.Body>
                      </Accordion.Item>
                    </> : 
                    <>
                    <Accordion.Item eventKey={index} key={account._id}>
                      <Accordion.Header>
                        <div className="accordion-header-content">
                          <div className="account-type-button">
                            {getAccountTypeName(account.accountTypeId, accountTypes)}
                          </div>
                          <div className="accordion-header-value">{getTotalRebate(account.accountTypeId, agreement?.totals)}</div>
                          <div className="accordion-header-value">{getTotalCommission(account.accountTypeId, agreement?.totals)}</div>
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Table className="table table-hover table-borderless text-center text-capitalize sub-table">
                        <Thead>
                          <Tr>
                            <Th>{t("Type")}</Th>
                            <Th>{t("Rebate")}</Th>
                            <Th>{t("Commission")}</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {Object.entries(account?.products ?? {}).map(([key, value]) =>
                            <Tr key={key}>
                              <Td className="account-type-cell">
                                <div className="account-type-button">{key}</div>
                              </Td>
                              <Td><span style={{ display: "inline-block", width: "100px" }} className="accordion-header-value">{value?.rebate}</span></Td>
                              <Td><span style={{ display: "inline-block", width: "100px" }} className="accordion-header-value">{value?.commission}</span></Td>
                            </Tr>
                          )}
                        </Tbody>
                      </Table>
                    </Accordion.Body>
                  </Accordion.Item>
                  </>
                  )}
                </Accordion>
              </Accordion.Body>
            </Accordion.Item>
          )}
        </Accordion>
      </CardBody>
    </Card>
    </>
  );
};

export default withTranslation()(AgreementDetails);
